import { useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse, PaymentMethod } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const usePaymentMethodActions = () => {
  const getPaymentMethodListHandler = useQuery({
    queryKey: ['payment-method-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<PaymentMethod>>> => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/payment/method/choices/'
      );

      return response.data;
    },

    ...returnQueryConfig(true),
  });

  return { getPaymentMethodListHandler };
};

export default usePaymentMethodActions;
